export { default } from './SkeletonFlightRecommenderMobile';
